import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form__buttons" };
const _hoisted_2 = {
    key: 0,
    class: "form__validation"
};
const _hoisted_3 = {
    key: 0,
    class: "form__validation-item"
};
const _hoisted_4 = ["disabled"];
import { computed, onUnmounted, reactive, ref, watch } from "vue";
import ValidationUtils from "../../services/ValidationUtils";
import Icon from "../Icon.vue";
import Spinner from "../Spinner.vue";
import FormValidator from "./FormValidator";
import formUtils from "./FormUtils";
import FormFields from "./FormFields.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppForm',
    props: {
        form: {},
        data: {},
        validation: {},
        variant: {},
        mode: {},
        loading: { type: Boolean },
        disabled: { type: Boolean },
        submitIcon: {},
        submitLabel: {},
        cancelLabel: {}
    },
    emits: [
        'change',
        'submit',
        'cancel',
        'bulkSelectToggle',
    ],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const props = __props;
        // the consumer's validation object, which the fields write their results into
        const localValidation = computed(() => reactive(props.validation || ValidationUtils.emptyValidation()));
        const hasValidationErrors = computed(() => !FormValidator.isValid(localValidation.value));
        const submitted = ref(false);
        function submit() {
            submitted.value = true;
            if (hasValidationErrors.value) {
                return;
            }
            formUtils.clearDirtyForm(props.form);
            emit('submit', props.data);
        }
        function cancel() {
            emit('cancel');
        }
        onUnmounted(() => formUtils.clearDirtyForm(props.form));
        watch(() => props.form, (newForm, oldForm) => {
            const formWasDirty = formUtils.isDirtyForm(oldForm);
            formUtils.clearDirtyForm(oldForm);
            if (oldForm.name === newForm.name && formWasDirty) {
                formUtils.registerDirtyForm(newForm);
            }
        });
        function onChange() {
            formUtils.registerDirtyForm(props.form);
            emit('change', props.data);
        }
        function onBulkSelectToggle(fieldPath) {
            emit('bulkSelectToggle', fieldPath);
        }
        __expose({
            submitted
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                onSubmit: _withModifiers(submit, ["prevent"]),
                class: _normalizeClass(["form", ['form--' + (__props.variant ?? 'simple'), 'form--mode-' + (__props.mode ?? 'standard')]]),
                novalidate: ""
            }, [
                _createVNode(FormFields, {
                    form: __props.form,
                    fields: __props.form.fields,
                    data: __props.data,
                    validation: localValidation.value,
                    submitted: submitted.value,
                    disabled: __props.loading,
                    mode: __props.mode,
                    onChange: onChange,
                    onBulkSelectToggle: onBulkSelectToggle
                }, null, 8, ["form", "fields", "data", "validation", "submitted", "disabled", "mode"]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _renderSlot(_ctx.$slots, "content"),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _renderSlot(_ctx.$slots, "form_buttons", {}, () => [
                    _createElementVNode("div", _hoisted_1, [
                        (submitted.value && hasValidationErrors.value)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localValidation.value.errors ?? [], (error, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "form__validation-item"
                                    }, _toDisplayString(_ctx.$t(error)), 1));
                                }), 128)),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                (localValidation.value.errors.length === 0)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_3, _toDisplayString(_ctx.$t('validation.has_field_errors')), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _renderSlot(_ctx.$slots, "submit", {}, () => [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "button button--primary",
                                disabled: __props.loading || __props.disabled
                            }, [
                                (__props.submitIcon && !__props.loading)
                                    ? (_openBlock(), _createBlock(Icon, {
                                        key: 0,
                                        name: __props.submitIcon
                                    }, null, 8, ["name"]))
                                    : _createCommentVNode("", true),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                _createVNode(Spinner, {
                                    loading: __props.loading ?? false
                                }, null, 8, ["loading"]),
                                _createTextVNode(" " + _toDisplayString(__props.submitLabel || _ctx.$t('submit')), 1)
                            ], 8, _hoisted_4)
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _renderSlot(_ctx.$slots, "buttons"),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _renderSlot(_ctx.$slots, "cancel", {}, () => [
                            (!__props.loading)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: _withModifiers(cancel, ["prevent"]),
                                    class: "button button--link button--cancel",
                                    href: ""
                                }, _toDisplayString(__props.cancelLabel || _ctx.$t('cancel')), 1))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ], 34));
        };
    }
});
